import { ClinicConfig } from '@app/icare/entities/clinic/config'
import { patientClinicQueries } from '@app/icare/entities/clinic/queries/patientClinicQueries'
import { PatientClinicEditDrawer } from '@app/icare/entities/patient/edits/PatientClinicEditDrawer'
import {
  patientFindingsQueryOptions,
  selectByGroupAndGroupByRelationId,
} from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientClinicRelation } from '@app/icare/entities/patient/schema/PatientClinic'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationOverview } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationOverview'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_clinic/kliniken/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientClinicQueries.forIndex(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()
  const { data: clinics = [] } = useSuspenseQuery(patientClinicQueries.forIndex(id))
  const { data: findings = {} } = useQuery({
    ...patientFindingsQueryOptions(id),
    select: selectByGroupAndGroupByRelationId('clinics'),
  })

  const handleAfterCommit = useRelationCommitNavigation<PatientClinicRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/kliniken/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })
  return (
    <RelationOverview
      items={clinics}
      labels={ClinicConfig}
      findings={findings}
      basePath={`/patienten/${id}/kliniken`}
      onEdit={params =>
        void PatientClinicEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
    />
  )
}
